import type { Room } from 'matrix-js-sdk'
import {
  CHAT_TYPES,
  MATRIX_EVENT_ROOM_STATE_TYPE,
  MATRIX_ROOM_META_STATE_TYPE,
} from '@/modules/chat-matrix-fast/constants/chat'

export interface MatrixEventRoomMeta {
  event_url?: string | null
  chat_id?: number
}

function readRoomStateContent(room: Room, eventType: string): Record<string, unknown> | null {
  const stateEvents = room.currentState?.getStateEvents(eventType, '')
  const event = Array.isArray(stateEvents) ? stateEvents[0] : stateEvents
  const content = event?.getContent?.()

  return content && typeof content === 'object'
    ? content as Record<string, unknown>
    : null
}

function parsePositiveInteger(value: unknown): number | undefined {
  if (typeof value === 'number') {
    return Number.isInteger(value) && value > 0 ? value : undefined
  }

  if (typeof value !== 'string' || !/^\d+$/.test(value.trim())) {
    return undefined
  }

  const parsed = Number(value)
  return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : undefined
}

export function getMatrixEventRoomMeta(room: Room): MatrixEventRoomMeta | null {
  const canonicalContent = readRoomStateContent(room, MATRIX_ROOM_META_STATE_TYPE)
  const legacyContent = readRoomStateContent(room, MATRIX_EVENT_ROOM_STATE_TYPE)
  const canonicalChatType = typeof canonicalContent?.chat_type === 'string'
    ? canonicalContent.chat_type.trim().toLowerCase()
    : ''
  const canonicalEventUrl = typeof canonicalContent?.event_url === 'string'
    ? canonicalContent.event_url
    : typeof canonicalContent?.url === 'string'
      ? canonicalContent.url
      : null

  // ru.daoit.room.meta присутствует у всех backend-комнат. Считаем его метаданными
  // НС только при явном chat_type=event (либо при наличии event_url для совместимости).
  const content = canonicalContent
    ? canonicalChatType === CHAT_TYPES.EVENT || canonicalEventUrl
      ? canonicalContent
      : null
    : legacyContent
  if (!content) {
    return null
  }

  const eventUrl = typeof content.event_url === 'string'
    ? content.event_url
    : typeof content.url === 'string'
      ? content.url
      : null
  const chatId = parsePositiveInteger(content.matrix_chat_id ?? content.chat_id)

  if (!eventUrl && !chatId) {
    return null
  }

  return {
    event_url: eventUrl,
    chat_id: chatId,
  }
}
